<template>
	<div class="app flex-row align-items-center">
		<div class="container">
			<b-row class="justify-content-center">
				<b-col md="6" sm="8">
					<b-card no-body class="mx-4">
						<b-card-body class="p-4">
							<b-form @submit="signUp">
								<b-img center src="../img/brand/LOGO SPC.png" alt="Center image"></b-img>
								<br>
								<h5 class="text-muted">Nueva cuenta de usuario.</h5>
								<b-input-group class="mb-3">
									<b-input-group-prepend>
										<b-input-group-text><i class="icon-user"></i></b-input-group-text>
									</b-input-group-prepend>
									<b-form-input type="text" class="form-control" placeholder="Cédula Física"
												  autocomplete="legal_id" v-model="user.legalID" required/>
								</b-input-group>

								<b-input-group class="mb-3">
									<b-input-group-prepend>
										<b-input-group-text><i class="icon-user"></i></b-input-group-text>
									</b-input-group-prepend>
									<b-form-input type="text" class="form-control"
												  placeholder="Cédula Jurídica de la Empresa"
												  autocomplete="juridical_id" v-model="user.accountID" required/>
								</b-input-group>

								<b-input-group class="mb-3">
									<b-input-group-prepend>
										<b-input-group-text><i class="icon-user"></i></b-input-group-text>
									</b-input-group-prepend>
									<b-form-input type="text" class="form-control" placeholder="Nombres"
												  autocomplete="first_name" v-model="user.firstName" required/>
								</b-input-group>

								<b-input-group class="mb-3">
									<b-input-group-prepend>
										<b-input-group-text><i class="icon-user"></i></b-input-group-text>
									</b-input-group-prepend>
									<b-form-input type="text" class="form-control" placeholder="Apellidos"
												  autocomplete="last_name" v-model="user.lastName" required/>
								</b-input-group>

								<b-input-group class="mb-3">
									<b-input-group-prepend>
										<b-input-group-text><i class="icon-user"></i></b-input-group-text>
									</b-input-group-prepend>
									<b-form-input type="text" class="form-control" placeholder="Nombre de Usuario"
												  autocomplete="username" v-model="user.userName" required/>
								</b-input-group>

								<b-input-group class="mb-3">
									<b-input-group-prepend>
										<b-input-group-text>@</b-input-group-text>
									</b-input-group-prepend>
									<b-form-input type="email" class="form-control" placeholder="Correo Electrónico"
												  autocomplete="email" v-model="user.email" required/>
								</b-input-group>

								<b-input-group class="mb-3">
									<b-input-group-prepend>
										<b-input-group-text><i class="icon-lock"></i></b-input-group-text>
									</b-input-group-prepend>
									<b-form-input type="password" class="form-control" placeholder="Contraseña"
												  autocomplete="new-password" v-model="user.password" required/>
								</b-input-group>

								<b-form-group class="mb-4">
									<b-input-group>
										<b-input-group-prepend>
											<b-input-group-text><i class="icon-lock"></i></b-input-group-text>
										</b-input-group-prepend>
										<b-form-input type="password" class="form-control"
													  placeholder="Confirmar Contraseña" required
													  autocomplete="new-password-confirm"
													  v-on:input="checkPassword"
													  v-model="user.passwordConfirm"/>
									</b-input-group>
									<small v-if="passwordError" class="text-danger">{{passwordError}}</small>
								</b-form-group>

								<b-input-group class="mb-4" v-if="errorMessage">
									<b-alert show variant="danger" class="m-0 w-100 text-center">{{errorMessage}}
									</b-alert>
								</b-input-group>

								<b-form-group class="mb-4" v-if="successMessage">
									<b-alert show variant="success" class="m-0 w-100 text-center">
										{{successMessage}}
									</b-alert>
								</b-form-group>

								<b-button v-if="!loading" variant="info" class="text-white" block type="submit">Crear
									Cuenta
								</b-button>
								<b-button v-if="loading" variant="primary" block disabled>
									<b-spinner small></b-spinner>
									Registrando Usuario...
								</b-button>
								<div class="text-center mt-2">
									<router-link :to="{name: 'Login'}">Iniciar Sesión</router-link>
								</div>
							</b-form>
						</b-card-body>
					</b-card>
				</b-col>
			</b-row>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'Register',
		data: function () {
			return {
				errorMessage: '',
				successMessage: '',
				passwordError: '',
				loading: false,
				user: {
					accountID: '',
					legalID: '',
					userName: '',
					firstName: '',
					lastName: '',
					email: '',
					password: '',
					passwordConfirm: ''
				}
			}
		},
		methods: {
			signUp(evt) {
				evt.preventDefault();

				if (this.user.legalID && this.user.accountID && this.user.userName && this.user.firstName && this.user.lastName && this.user.email && this.user.password && this.user.passwordConfirm) {
					this.loading = true;
					this.$store.dispatch('signUp', this.user)
						.then((response) => {
							console.log(response);
							this.successMessage = response;
							this.cleanForm();
						})
						.catch((err) => {
							if (err.status === 400) {
								this.errorMessage = err.data.Message;
							}
						})
						.finally(() => {
							this.loading = false;
						})
				} else {

				}
			},
			checkPassword(event) {
				if (this.user.password !== this.user.passwordConfirm) {
					this.passwordError = 'Las contraseñas no coinciden';
				} else {
					this.passwordError = '';
				}
			},
			cleanForm() {
				this.user = {
					accountID: '',
					legalID: '',
					userName: '',
					firstName: '',
					lastName: '',
					email: '',
					password: '',
					passwordConfirm: ''
				}
			}
		}
	}
</script>
